import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import PromptHistoryPanel from "./promptHistoryPanel";

export const gridStyle = { height: 75, padding: "0px" };

// Campos disponibles antes de la primera generación: la indicación para la IA
// y los datos de cabecera que se envían al endpoint de generate.
const BaseFields = ({ formData, setFormValue, isCreate, activeTypes, roleTypes, promptHistory }) => {

  return (
    <Grid container item xs={12} style={{ marginTop: 8, marginBottom: 8, padding: "0px" }}>
      <Grid container item alignItems="center" xs={12} sm={6} md={4} style={{ ...gridStyle, padding: "8px 10px" }}> {/* codigo */}
        <TextField
          disabled={!Boolean(isCreate)}
          required
          fullWidth
          margin={"none"}
          label={getLocalizedString("codeAlt")}
          onChange={(e) => setFormValue(e.target.value, "code")}
          value={formData.code}
          inputProps={{ maxLength: 20 }}
        />
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} md={4} style={{ ...gridStyle, padding: "8px 10px" }}> {/* nombre */}
        <TextField
          required
          fullWidth
          margin={"none"}
          label={getLocalizedString("name")}
          value={formData.name}
          onChange={(e) => setFormValue(e.target.value, "name")}
          inputProps={{ maxLength: 254 }}
        />
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} md={4} style={{ ...gridStyle, padding: "8px 10px" }}> {/* Activa */}
        <FormControl style={{ width: "100%" }}>
          <InputLabel required id={`label-active`}>{getLocalizedString("activeFemale")}</InputLabel>
          <Select
            value={formData.active}
            labelId={`label-active`}
            id={`select-active`}
            onChange={(e) => setFormValue(e.target.value, "active")}
            margin={"none"}
          >
            {
              activeTypes && activeTypes.map(item => (
                <MenuItem
                  className={"whiteText"}
                  key={item.key}
                  value={item.key}>
                  {item.value}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Grid>
      {
        Boolean(promptHistory && String(promptHistory).trim()) &&
        <Grid container item alignItems="center" xs={12} style={{ padding: "16px 0px 0px", marginTop: 8 }}> {/* historial de indicaciones */}
          <PromptHistoryPanel promptHistory={promptHistory} />
        </Grid>
      }
      <Grid container item alignItems="center" xs={12} style={{ padding: "16px 10px", marginTop: 8 }}> {/* request */}
        <TextFieldMultiline
          required
          fullWidth
          label={getLocalizedString("aiGeneratedSQL")}
          rows={10}
          margin={"none"}
          value={formData.request}
          onChange={(e) => setFormValue(e.target.value, "request")}
          inputProps={{ spellCheck: 'false' }}
        />
      </Grid>
      <Grid container item alignItems="center" sm={12} md={6} style={{ ...gridStyle, height: 95, padding: "8px 10px", marginTop: 16 }}> {/* group */}
        <TextField
          required
          fullWidth
          margin={"none"}
          label={getLocalizedString("locationGroup")}
          value={formData.group}
          onChange={(e) => setFormValue(e.target.value, "group")}
          inputProps={{ maxLength: 100 }}
          helperText={getLocalizedString("specialLocationGroupsMyStaffPeopleMasterPersonalDataUserMenuAndTest")}
        />
      </Grid>
      <Grid container item alignItems="center" xs={12} md={6} style={{ ...gridStyle, padding: "8px 10px", marginTop: 11 }}> {/* role */}
        <FormControl style={{ width: "100%" }}>
          <InputLabel required id={`label-role`}>{getLocalizedString("viewRole")}</InputLabel>
          <Select
            value={formData.rol}
            labelId={`label-role`}
            id={`select-role`}
            onChange={(e) => setFormValue(e.target.value, "rol")}
            margin={"none"}
          >
            {
              roleTypes && roleTypes.map(item => (
                <MenuItem
                  className={"whiteText"}
                  key={item.key}
                  value={item.key}>
                  {item.value}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default BaseFields;
